import React, { FC, Suspense, lazy } from 'react';

import { ContentfulNavBar } from 'src/components/NavBar/ContentfulNavBar';
import { useV2Route } from 'src/hooks/UseV2Route';

/** Only load for V2 routes */
const NavBarV2 = lazy(async () => {
  const module = await import('src/components/NavBarV2/NavBarV2');
  return { default: module.NavBarV2 };
});

export interface SiteHeaderProps extends React.AllHTMLAttributes<HTMLElement> {
  mainContentRef?: React.RefObject<HTMLDivElement>;
  children?: never;
}

export const SiteHeader: FC<SiteHeaderProps> = props => {
  const isV2 = useV2Route();

  if (isV2) {
    return (
      <Suspense fallback={null}>
        <NavBarV2 {...props} />
      </Suspense>
    );
  }

  return <ContentfulNavBar {...props} />;
};

SiteHeader.displayName = 'SiteHeader';
